module.exports = __webpack_public_path__ + "c4a19e76fc0e84c08e16a0540d70d819.png";